module.exports = __webpack_public_path__ + "static/media/swap-hover.a40edfd5.svg";